import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
/**
 * Colors_B2C_T4.jsx
 * Identity for B2C Template 4 (Forest Green & Copper Theme)
 * Fully synchronized with MongoDB Case-Sensitive keys.
 */

// 1. Content Mapper for B2C T4
export const mapB2CTenantToLanding = (tenantData) => {
  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    logoUrl:         getLocalLogoUrl(tenantData?.domain),
    brandName:       tenantData?.branding?.brandName    || 'Forest Portal',
    email:           tenantData?.branding?.email        || 'support@corporate.com',
    
    // Support for both Array or String from DB
    phones:          Array.isArray(tenantData?.branding?.phones) 
                     ? tenantData?.branding?.phones[0] 
                     : tenantData?.branding?.phones || '9177656344',
                     
    whatsapp:        tenantData?.branding?.whatsapp     || '9177656344',
    socials:         tenantData?.branding?.socials      || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    // ⭐ KEY FIX: Extracting exactly from camelCase MongoDB keys (themeColor, not themecolor)
    themeColor1:     tenantData?.theme?.themeColor1, 
    themeColor2:     tenantData?.theme?.themeColor2,
    themeColor3:     tenantData?.theme?.themeColor3,
    themeColor4:     tenantData?.theme?.themeColor4,
    themeColor5:     tenantData?.theme?.themeColor5,

    // Overrides from Header/Footer JSON objects
    headerBgOverride:   tenantData?.header?.bgColor,
    headerTextOverride: tenantData?.header?.textColor,
    footerBgOverride:   tenantData?.footer?.bgColor,
    footerTextOverride: tenantData?.footer?.textColor,

    headerMenu:      tenantData?.header,
    footerAboutText: tenantData?.footer?.aboutText,
    footerCopyright: tenantData?.footer?.copyright,
    
    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
    destinations:    tenantData?.destinations,
    activeModules:   tenantData?.activeModules,
    
    metaTitle:       tenantData?.seo?.metaTitle,
    metaDescription: tenantData?.seo?.metaDescription,
  };
};

// 2. Color Resolver for B2C T4
export const getB2CColors_T4 = (landingData) => {
  // Mapping the requested T4 TOKENS as fallbacks
  // If landingData.themeColor1 exists (which it will now), it uses that.
  const copper      = landingData?.themeColor1 || "#B87333";
  const ink         = landingData?.themeColor2 || "#1A2E27"; 
  const surface     = landingData?.themeColor3 || "#FFFFFF";
  const forestGreen = landingData?.themeColor4 || "#2C4A3E";
  const almond      = landingData?.themeColor5 || "#F5EDD9";
  
  
  return {
    theme1: copper, 
    theme2: landingData?.footerBgOverride || ink, 
    theme3: landingData?.headerBgOverride || ink, // Header is Dark Ink in T4 design
    theme4: forestGreen,
    theme5: almond,

    // Smart Text colors for T4 (Forest Green & Copper aesthetic usually uses light text on dark backgrounds)
    headerText: landingData?.headerTextOverride || almond,
    footerText: landingData?.footerTextOverride || almond,
  };
};